/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import color from '../_style/color';

const NavBarWebWrapper = styled.div`
  display: flex;
  border-top: ${({ minimize }) =>
    minimize ? 0 : `1px solid ${color.gainsboro}`};
  box-sizing: border-box;
  height: ${({ minimize }) => (minimize ? 0 : 'auto')};
  width: 100%;
`;

const HorizontalNavigations = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 40px;
  box-sizing: border-box;
  padding: 0 0 0 10px;
  overflow: hidden;
  height: ${({ minimize }) => (minimize ? 0 : 'auto')};
`;

const VerticalNavigations = styled.div`
  position: absolute;
  top: 41px;
  right: 10px;
  height: 0px;
  opacity: 0;
  padding: 0;
  visibility: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #dadada;
  border-top: none;
  transition: all 0.3s ease;

  div:nth-child(-n + ${(props) => props.elementToHide}) {
    display: none;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      height: auto;
      opacity: 1;
      padding: 10px 0;
      visibility: visible;
    `}
`;

const NavMoreLogoWrapper = styled.div`
  border-width: 0 1px;
  border-color: ${({ isOpen }) => (isOpen ? '#dadada' : '#ffffff')};
  border-style: solid;
  cursor: pointer;
  position: relative;
  right: 10px;

  ::after {
    content: '';
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    width: 50px;
    height: 1px;
    background-color: ${color.light};
    position: absolute;
    bottom: -1px;
    z-index: 2;
  }
`;

const Relative = styled.div`
  display: ${({ minimize }) => (minimize ? 'none' : 'block')};
  position: relative;
`;

const NavMoreWrapper = ({ Logo, children, minimize, elementToHide }) => {
  const [hideModal, setModal] = useState(true);
  const navMoreRef = useRef();

  const onNavMoreClick = (e) => {
    if (navMoreRef.current.contains(e.target)) {
      return setModal(!hideModal);
    }
    return setModal(true);
  };

  useEffect(() => {
    document.addEventListener('click', onNavMoreClick);
    return () => {
      document.removeEventListener('click', onNavMoreClick);
    };
  });

  return (
    <Relative minimize={minimize}>
      <NavMoreLogoWrapper
        ref={navMoreRef}
        isOpen={!hideModal}
        onClick={(e) => onNavMoreClick(e)}
      >
        <Logo />
      </NavMoreLogoWrapper>
      <VerticalNavigations isOpen={!hideModal} elementToHide={elementToHide}>
        {children}
      </VerticalNavigations>
    </Relative>
  );
};

const NavBarComponent = ({
  className,
  minimize,
  children,
  expandNavLogo = () => <div />,
}) => {
  const [moreNavElement, setMoreNavElement] = useState([]);
  const navHorizontalRef = useRef();
  const ExpandNavLogo = expandNavLogo;

  useEffect(() => {
    const updateNavigation = () => {
      const navigation = navHorizontalRef.current.children;
      const moreNavigation = [...navigation]
        .filter((e) => e.offsetTop === 0)
        .map((e) => e.innerText);
      setMoreNavElement(moreNavigation);
    };

    const timeoutId = setTimeout(updateNavigation, 0);

    window.addEventListener('resize', updateNavigation);

    return () => {
      window.removeEventListener('resize', updateNavigation);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <NavBarWebWrapper className={className} minimize={minimize}>
      <HorizontalNavigations ref={navHorizontalRef} minimize={minimize}>
        {children}
      </HorizontalNavigations>
      <NavMoreWrapper
        minimize={minimize}
        Logo={() => <ExpandNavLogo />}
        elementToHide={moreNavElement.length}
      >
        {children}
      </NavMoreWrapper>
    </NavBarWebWrapper>
  );
};

export default NavBarComponent;
